import { render, staticRenderFns } from "./CustomSelectionStartpageView.vue?vue&type=template&id=7522b270&scoped=true&"
import script from "./CustomSelectionStartpageView.vue?vue&type=script&lang=js&"
export * from "./CustomSelectionStartpageView.vue?vue&type=script&lang=js&"
import style0 from "./CustomSelectionStartpageView.vue?vue&type=style&index=0&id=7522b270&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7522b270",
  null
  
)

export default component.exports